import { Pipe, PipeTransform } from '@angular/core';

import { ProgrammingUtilsService, DAYS_OF_THE_WEEK, MONTHS_OF_THE_YEAR, WEEKS_OF_THE_MONTH } from './../../../common/services/utils.service';
import { ScheduleQuickstartContext } from './../services/schedule.service';

@Pipe({
  name: 'startDateLabel'
})
export class StartdateLabelPipe implements PipeTransform {

  constructor(
    private utils: ProgrammingUtilsService
  ) { }

  transform(vm: ScheduleQuickstartContext, args?: any): any {
    // console.log('preparing start date label', vm);
    let label = 'Starting on ';

    if (vm) {
      if (vm.isFixedDate) {
        let parts = vm.startDate.split('-');
        label += this.utils.toDateDisplay(parseInt(parts[0]), parseInt(parts[1]), parseInt(parts[2]));
        label += ', ';
      } else {
        label += 'the ';
        label += WEEKS_OF_THE_MONTH[vm.startWeekOffset];
        label += ' ';
        label += DAYS_OF_THE_WEEK[vm.startDayOfWeek];
        label += ' of ';
        label += MONTHS_OF_THE_YEAR[vm.startMonth];
        label += ', ';
        label += vm.startYear;
      }
    }

    return label;
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/pipes/startdate-label.pipe.ts